// extracted by mini-css-extract-plugin
export default {"title":"LangSwitch_title__QzM6b","language":"LangSwitch_language__5qQ96","flagBox":"LangSwitch_flagBox__0LLIX","fill":"LangSwitch_fill__7kFVc","flag":"LangSwitch_flag__iluoo"};